import { getMinutesBetweenDates } from "../../community-hats-js-library/utils/dateFunctions";
import { parse, format, addMinutes, isBefore } from "date-fns";

export const getMinuteInterval = (startDate, endDate, timeInterval, frequency, minDataFrequency) => {
    // Creates Structure
    const totalMinutes = getMinutesBetweenDates(startDate, endDate);
    // Rule of Three
    let minuteInterval = totalMinutes * (frequency / 60) / timeInterval

    // Adjusts to 15 minute intervals
    let mod = minuteInterval % minDataFrequency
    if (mod > 0 && mod < minDataFrequency / 2)
        minuteInterval -= mod
    else if (mod > 0 && mod >= minDataFrequency / 2)
        minuteInterval += minDataFrequency - mod

    return minuteInterval
}


export const getIntervalSteps = (startDate, endDate, timeInterval, frequency, minDataFrequency) => {

    const FORMAT = "yyyy-MM-dd HH:mm:ss";

    let minInterval = getMinuteInterval(startDate, endDate, timeInterval, frequency, minDataFrequency);

    // parse input strings into Date objects
    let start = parse(startDate, FORMAT, new Date());
    let end = parse(endDate, FORMAT, new Date());

    let steps = [];
    let current = start;

    while (isBefore(current, end)) {
        steps.push(format(current, FORMAT));
        current = addMinutes(current, minInterval);
    }

    return steps;


}

export const getRisk = (heartRate, humidity, temperature) => {

    let heatIndex = getHeatIndex(humidity, temperature)


    // console.log(humidity)
    // console.log(temperature)
    // console.log(heatIndex)
    // console.log("----------")

    // Tresholds from https://www.weather.gov/ffc/hichart
    if (heatIndex < 80)
        return 0

    if (heatIndex < 90)
        return 1

    if (heatIndex < 105)
        return 2

    if (heatIndex < 129)
        return 3

    return 4
}

export const getHeatIndex = (humidity, temperature) => {




    // Temp implementation
    return (-42.379 + 2.04901523 * temperature + 10.14333127 * humidity - 0.22475541 * temperature * humidity
        - 0.00683783 * temperature * temperature - 0.05481717 * humidity * humidity
        + 0.00122874 * temperature * temperature * humidity + 0.00085282 * temperature * humidity * humidity
        - 0.00000199 * temperature * temperature * humidity * humidity);



    //         // Coefficients
    // const c1 = -8.78469475556;
    // const c2 = 1.61139411;
    // const c3 = 2.33854883889;
    // const c4 = -0.14611605;
    // const c5 = -0.012308094;
    // const c6 = -0.0164248277778;
    // const c7 = 0.002211732;
    // const c8 = 0.00072546;
    // const c9 = -0.000003582;


    //         // Calculation
    // let heatIndex = c1 +
    //     c2 * temperature +
    //     c3 * humidity +
    //     c4 * temperature * humidity +
    //     c5 * temperature ^ 2 +
    //     c6 * humidity ^ 2 +
    //     c7 * humidity * temperature ^ 2 +
    //     c8 * temperature * humidity ^ 2 +
    //     c9 * temperature ^ 2 * humidity ^ 2



    // return heatIndex
};